module.exports = __webpack_public_path__ + "static/img/building-highlight.857a533.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/building-highlight.png
// module id = 424
// module chunks = 1